import React, { useState, useEffect } from "react";
import {
  faArrowRightArrowLeft,
  faChevronLeft,
  faChevronRight,
  faClock,
  faClockRotateLeft,
  faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSwipeable } from "react-swipeable";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CHAIN, MORALIS_API_KEY, SERVER_URL, AVALANCHE_RPC } from "../../../Config";
import axios from "axios";
import { ethers } from "ethers";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { ClipLoader } from "react-spinners";
import { token_abi, usdccontractaddress, usdtcontractaddress } from "../../../abi";

const Withdraw = () => {

  const [isSwipedRight, setIsSwipedRight] = useState(false);
  const [UserAccounts, setUserAccounts] = useState([])
  const navigate = useNavigate()
  const [userData, setuserData] = useState([])
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [userWallets, setUserWallets] = useState([]);
  const [showLoader, setshowLoader] = useState(false)

  const [receiverInput, setReceiverInput] = useState("");
  const [withdrawWallet, setWithdrawWallet] = useState('');
  const [selectedWallet, setSelectedWallet] = useState("");
  const [selectedToken, setSelectedToken] = useState("");
  const [amount, setAmount] = useState("");
  const [recentHistory, setRecentHistory] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [users, setUsers] = useState([]);
  const [totalBalance, setTotalBalance] = useState(0);
  const [tokenListt, setTokenList] = useState([]);

  const tokenList = [
    {
      name: "Tether USD",
      symbol: "USDT",
      address: "0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7",
      decimal: 6
    },
    {
      name: "USD Coin",
      symbol: "USDC",
      address: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E",
      decimal: 6
    }
  ];

  const getUserdatas = async () => {
    try {
      setshowLoader(true)
      const token = sessionStorage.getItem('_token');
      if (!token) {
        toast.error('Session Expired');
        setshowLoader(false)
        navigate('/Login');
        return;
      }

      const decodedToken = jwtDecode(token);
      const res = await axios.get(`${SERVER_URL}/api/getUserdatas?AppID=${decodedToken.AppID}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.status) {

        setuserData(res.data.User);
        setUserAccounts(res.data.accounts)
        const choosedAccount = sessionStorage.getItem('selectedAccount');

        if (!choosedAccount) {
          setSelectedAccount(res.data.accounts.length > 0 ? res.data.accounts[0].wallet_address : null);
          sessionStorage.setItem('selectedAccount', res.data.accounts.length > 0 ? res.data.accounts[0].wallet_address : null)
        } else {
          setSelectedAccount(sessionStorage.getItem('selectedAccount'))
        }
      } else {
        setuserData([]);
        setSelectedAccount(null);
      }
      setshowLoader(false)
    } catch (error) {
      console.error('Error fetching user data:', error);

      if (error.response?.status === 403) {
        toast.error('Session expired');
        navigate('/Login');
      } else {
        toast.error('Something went wrong. Please try again.');
      }
      setshowLoader(false)
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem('_token');
    if (token) {
      getUserdatas();
    }
  }, [sessionStorage.getItem('_token')]);

  const isValidEvmAddress = (address) => {
    return ethers.utils.isAddress(address);
  };

  const handleTransfer = async () => {
    setshowLoader(true)
    try {
      const token = sessionStorage.getItem('_token');
      if (!token) {
        toast.error('Session Expired');
        setshowLoader(false)
        navigate('/Login');
        return;
      }

      if (!selectedToken) {
        toast.error("Select the token");
        setshowLoader(false)
        return;
      }
      if (selectedAccount === withdrawWallet) {
        toast.error("Sender and recipient addresses cannot be the same");
        setshowLoader(false)
        return;
      }
      if (!amount || amount <= 0) {
        toast.error("Enter a valid amount");
        setshowLoader(false)
        return;
      }
      if (!withdrawWallet) {
        toast.error("Enter the recipient address");
        setshowLoader(false)
        return;
      }
      if (!isValidEvmAddress(withdrawWallet)) {
        toast.error("Invalid recipient address");
        setshowLoader(false)
        return;
      }
      let tokenbalance = await getTokenBalance(selectedAccount, selectedToken?.address, selectedToken?.decimal, selectedToken?.symbol)
      console.log(tokenbalance, amount)
      if (Number(tokenbalance) < Number(amount)) {
        toast.error("Insufficient balance");
        setshowLoader(false)
        return;
      }

      const transferData = {
        from_id: userData.app_id,
        fromAddress: selectedAccount,
        toAddress: withdrawWallet,
        tokenAddress: selectedToken?.address,
        tokenSymbol: selectedToken?.symbol,
        amount,
      };


      const transferRes = await axios.post(`${SERVER_URL}/api/withdraw`, transferData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (transferRes.data.status === true) {
        toast.success("Transfer successful!");
        setshowLoader(false)
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        toast.error(transferRes.data.message || "Transfer failed. Please try again.");
        setshowLoader(false)
      }
    } catch (error) {
      console.error("Transfer error:", error);
      toast.error("Something went wrong. Please try again.");
      setshowLoader(false)
    }
  };

  const getUserTransactions = async (app_id) => {
    setshowLoader(true)
    try {
      const res = await axios.get(`${SERVER_URL}/api/getwithdrawTransaction?app_id=${app_id}`);
      if (res.data.status) {
        setRecentHistory(res.data.transactionsData);
      } else {
        console.error("Error fetching transactions:", res.data.message);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
    setshowLoader(false)
  };

  const fetchBalances = async () => {
    setshowLoader(true)
    try {
      const response = await fetch(
        `https://deep-index.moralis.io/api/v2.2/${selectedAccount}/erc20?chain=${CHAIN}`,
        {
          method: "GET",
          headers: {
            "accept": "application/json",
            "X-API-Key": MORALIS_API_KEY,
          },
        }
      );

      const data = await response.json();
      if (Array.isArray(data)) {
        let total = 0;

        const formattedBalances = data.map((token) => {
          const balance = token.balance / Math.pow(10, token.decimals);
          total += balance;
          return {
            name: token.name,
            symbol: token.symbol,
            balance: balance.toFixed(4),
            address: token.token_address,
            decimal: token.decimals
          };
        });

        setTotalBalance(total.toFixed(4));
        setTokenList(formattedBalances)
      }
    } catch (error) {
      console.error("Error fetching balances:", error);
    }
    setshowLoader(false)
  };

  const getTokenBalance = async (walletAddress, tokenAddress, tokenDecimal, symbol) => {
    try {
      const provider = new ethers.providers.JsonRpcProvider(AVALANCHE_RPC);
      const TokenContract = new ethers.Contract(tokenAddress, token_abi, provider);
      const balance = await TokenContract.balanceOf(walletAddress);
      return Number(ethers.utils.formatUnits(balance, tokenDecimal));
    } catch (error) {
      console.error(`Error fetching ${symbol} balance:`, error);
      return 0;
    }
  };

  useEffect(() => {
    if (selectedAccount !== null) {
      fetchBalances();
    }
  }, [selectedAccount]);

  useEffect(() => {
    if (userData?.app_id) {
      getUserTransactions(userData.app_id);
    }
  }, [userData]);

  const filteredTransactions = recentHistory?.filter((data) =>
    data?.from_id?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    data.to_wallet.toLowerCase().includes(searchQuery.toLowerCase()) ||
    data.from_wallet.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const ViewHash = (hash) => {
    window.open(`https://snowtrace.io/tx/${hash}`, "_blank");
  };

  return (
    <div className="w-full bg-[#060606] relative h-full overflow-hidden overflow-y-auto text-white font-poppins ">
      <div
        className="z-0 absolute -top-36 left-0 right-0 w-[90%] mx-auto h-96 opacity-30 "
        style={{ background: "radial-gradient(50% 50% at 50% 50%, #FFF2C2 0%, rgba(0, 0, 0, 0) 100%)", }}
      ></div>
      <div className="md:px-10 px-5 pt-10">
        <p className="font-Artemus text-xl ">Withdraw</p>
        <hr className=" border border-[#856E4F] w-7 " />
      </div>
      <div className=" mt-10 flex lg:flex-row flex-col gap-28 lg:gap-0">
        <div className="lg:w-1/2 w-full h-full ">
          <div className=" w-[95%] h-full flex flex-col justify-center items-center mx-auto max-w-lg z-30 relative ">

            <div className="lg:h-full">
              <img
                src="../assets/other/Send1.svg"
                className=" mx-auto lg:-translate-y-12 z-0 lg:h-full w-8/12 lg:w-10/12 "
              />
            </div>

            <div className="z-10 absolute top-0 w-full lg:h-full flex flex-col justify-center items-center bg-gradient-to-b from-[#0B0F10]/50 to-[#241D14]/50 rounded-2xl border border-[#2F2F2F] lg:py-0 py-5  px-10  ">
              <div>
                <p className="font-Artemus text-xl text-center ">Withdraw</p>
              </div>
              <div className="w-full font-montserrat mt-2 text-sm ">
                <div
                  className="bg-black/60 text-white truncate rounded w-full px-5 py-2 mb-3 focus:outline-none text-sm border border-[#F6FFE91F]"
                >{selectedAccount}
                </div>
                <div className="">
                  <select
                    className=" text-white text-sm bg-black/60 rounded w-full px-5 py-2 focus:outline-none border border-[#F6FFE91F]"
                    value={selectedToken?.symbol || ""}
                    onChange={(e) => {
                      const selected = tokenList.find((token) => token.symbol === e.target.value);
                      setSelectedToken(selected || null);
                    }}
                  >
                    <option className="bg-black text-white" value="">Choose Token</option>
                    {tokenList.map((token) => (
                      <option className="bg-black text-white" key={token.symbol} value={token.symbol}>
                        {token.symbol} - {token.name}
                      </option>
                    ))}
                  </select>

                </div>
                <div className=" my-5 flex justify-center ">
                  <FontAwesomeIcon
                    icon={faArrowRightArrowLeft}
                    size="lg"
                    className=" rotate-90 "
                  />
                </div>
                <div>
                  <input
                    type="text"
                    className="bg-black/60 text-white rounded w-full px-5 py-2 focus:outline-none text-sm border border-[#F6FFE91F]"
                    value={withdrawWallet}
                    onChange={(e) => { setWithdrawWallet(e.target.value) }}
                    placeholder="Enter Withdraw address"
                  />
                </div>
                <div className="mt-2 ">
                  <input
                    type="number"
                    className="bg-black/60 text-white rounded w-full px-5 py-2 focus:outline-none text-sm border border-[#F6FFE91F]"
                    value={amount}
                    min={0}
                    onChange={(e) => {
                      const inputAmount = parseFloat(e.target.value);
                      if (!isNaN(inputAmount) && inputAmount >= 0) {
                        setAmount(inputAmount);
                      } else {
                        setAmount("");
                      }
                    }}
                    placeholder="Enter Amount"
                  />
                </div>

                <div className="mt-10 ">
                  <div className="bg-gradient-to-br from-[#F6FFE9] to-[#94998C] p-0.5 rounded-full">
                    <div
                      className={`relative ${isSwipedRight
                        ? "bg-green-500"
                        : "bg-gradient-to-r from-[#0B0F10] to-[#241D14]"
                        } rounded-full p-2 flex justify-center items-center`}
                    >
                      <div
                        onClick={handleTransfer}
                        className={`w-[100%] mx-auto absolute left-1 transition-transform duration-500 ${isSwipedRight
                          ? "md:translate-x-[88%] translate-x-[82%]"
                          : "translate-x-0"
                          }`}
                      >
                        <div
                          className={`w-10 h-10 cursor-pointer rounded-full bg-white flex justify-center items-center`}
                        >
                          <FontAwesomeIcon
                            icon={faChevronRight}
                            className=""
                            style={{ color: "#856E4F" }}
                          />
                          <FontAwesomeIcon
                            icon={faChevronRight}
                            className="-translate-x-1"
                            style={{ color: "#856E4F" }}
                          />
                        </div>
                      </div>
                      <div className="w-[90%] mt-1">
                        <p className="font-Artemus text-lg text-center font-medium">
                          Transfer
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div className="lg:w-1/2 w-full md:pr-10 px-3 pb-10 md:pb-0">
          <div className=" max-w-lg mx-auto lg:w-full z-30 w-full bg-gradient-to-b from-[#0B0F10]/50 to-[#241D14]/50 rounded-2xl border border-[#2F2F2F] p-5 ">
            <div className="flex items-center gap-2">
              <p className="font-Artemus text-lg uppercase mt-1 z-30">
                Recent History
              </p>
              <FontAwesomeIcon icon={faClockRotateLeft} />
            </div>

            <div className="relative z-30 mt-3">
              <input
                className="w-full focus:outline-none text-sm font-medium bg-transparent rounded-full border border-white/15 pl-10 pr-3 py-2 placeholder:text-white/50"
                placeholder="Enter withdrawal address" value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <span className="absolute top-2 left-3">
                <FontAwesomeIcon
                  icon={faMagnifyingGlass}
                  className="text-white/30"
                />
              </span>
            </div>

            <div className="mt-5">
              {filteredTransactions?.length > 0 ? (
                filteredTransactions?.slice(0, 4)?.map((data, index) => (
                  <div key={index} className="bg-[#D9D9D90D] mt-3 rounded-xl py-2.5 px-5 flex justify-between gap-5 items-center ">
                    <div className="flex items-center gap-2">
                      <img src='../assets/Profile/Sendprofile5.svg' className=" w-10 h-10 " />
                      <div>
                        <p className="text-sm truncate">
                          {data.to_wallet?.slice(0, 4)}...{data.to_wallet?.slice(-6)}
                        </p>
                        <p className=" text-xs  font-light">{data.created_at}</p>
                      </div>
                    </div>

                    <div className="flex items-center gap-3 text-sm">
                      <p className=" text-sm">{data.amount} {data.token_name}</p>
                      <FontAwesomeIcon icon={faChevronRight} size="sm" onClick={() => ViewHash(data.trn_hash)} className="cursor-pointer" />
                    </div>
                  </div>
                ))) : (
                <p className="text-center text-gray-500">No transactions found.</p>
              )}
            </div>
          </div>

        </div>

      </div>

      {showLoader && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999, // Ensures overlay appears on top
            backdropFilter: "blur(5px)", // Apply blur effect to background
          }}
        >
          <div className="flex flex-col gap-4 justify-center items-center">
            <ClipLoader color="#ffffff" size={50} />
            <p style={{ color: "#ffffff", fontSize: "18px" }} className="text-center">
              Loading...
            </p>
          </div>

        </div>
      )}
    </div >
  );
};

export default Withdraw;
